import { defineModule } from '@nexus/core';
import { STATES } from './types';

/** Contract between the module and the kernel (docs/architecture/modules.md). */
export const manifest = defineModule({
  id: 'legal',
  name: 'legal.name',
  description: 'legal.description',
  icon: 'scale',
  base: true,
  permissions: [
    { key: 'legal.norm.read' },
    // Changes what search, lookups of other modules and the AI drafts rely on.
    { key: 'legal.source.manage', privileged: true },
    // Downloads from official portals: catalog, "Neu abrufen", own addresses. Calls out to the
    // internet and replaces wording, on top of managing the sources.
    { key: 'legal.source.fetch', privileged: true },
  ],
  defaultRoles: [
    {
      key: 'reader',
      name: 'legal.roles.reader',
      // Laws and rules are public works (§ 5 UrhG); everyone in the company may look them up.
      everyone: true,
      grants: [{ permission: 'legal.norm.read', scope: null }],
    },
    {
      key: 'manager',
      name: 'legal.roles.manager',
      grants: [
        { permission: 'legal.norm.read', scope: null },
        { permission: 'legal.source.manage', scope: null },
        { permission: 'legal.source.fetch', scope: null },
      ],
    },
  ],
  navigation: [
    { label: 'legal.nav.texts', path: '/legal', icon: 'scale', permission: 'legal.norm.read' },
    {
      label: 'legal.nav.sources',
      path: '/legal/sources',
      icon: 'settings',
      permission: 'legal.source.manage',
    },
  ],
  settings: [
    {
      // Federal law and model codes always count; the state adds its own law.
      key: 'legal.state',
      level: 'user',
      type: 'select',
      options: ['all', ...STATES],
      default: 'all',
    },
  ],
  search: [{ entity: 'legal.source', permission: 'legal.norm.read' }],
  // Files a person downloaded from an official portal and uploads at the source, until a
  // retrieval has read them (README, "Datei hochladen").
  files: [
    {
      entity: 'legal.source',
      read: 'legal.source.fetch',
      write: 'legal.source.fetch',
      // XML export of a law portal, the PDF of a rule, or the full text as a text file.
      kinds: ['xml', 'archive', 'pdf', 'text'],
      // The export of a regulation with its annexes as PDF had 9 MB.
      maxBytes: 25_000_000,
    },
  ],
  dataProcessing: [
    {
      entity: 'legal.source',
      purpose:
        'Hochgeladene Rechtstexte aus amtlichen Quellen (XML-Export, PDF oder Volltext), bis ein Abruf sie gelesen hat; wer hochgeladen hat, steht an der Datei',
      legalBasis: 'Art. 6 Abs. 1 lit. f DSGVO',
      categories: ['account-id', 'file-name'],
      // The retrieval removes the file once read; this catches files no retrieval read.
      retention: { period: 'P7D', after: 'upload' },
      erase: 'delete',
    },
  ],
});
